import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { DIRECTION } from '../global-constants';

const Navigator = (
	{ handleNavigator, direction, isMobile, chipColorClasses = '' },
	ref
) => {
	const isRightNavigator = direction === DIRECTION.RIGHT;
	if (isMobile) {
		return null;
	}
	return (
		<div className={`navigator-${direction}`} ref={ref}>
			<button
				className={`btn-no-decoration chip ${chipColorClasses}`}
				type="button"
				aria-label={`Go to ${
					isRightNavigator ? 'next' : 'previous'
				} item`}
				onClick={(e) => handleNavigator(e, direction)}
				title={`View  ${
					isRightNavigator ? 'next' : 'previous'
				} item of highlight facet`}
			>
				<i
					className={`ddc-icon ddc-icon-arrow4-${direction}`}
					aria-hidden="true"
				/>
			</button>
		</div>
	);
};

Navigator.propTypes = {
	handleNavigator: PropTypes.func,
	direction: PropTypes.string,
	isMobile: PropTypes.bool,
	chipColorClasses: PropTypes.string
};

export default forwardRef(Navigator);
